import { IRestfulApiService } from '@/lib/apiService'
import {
	GetProtectionByRNumberQueryDTO,
	GetProtectionByRNumberResponseDTO,
	IQueryCommand,
} from '@bookips/solvook-api-shared'

/**
 * R 인증번호 조회
 * @param r_number SearchRNumberQueryDTO
 * @returns Promise<GetProtectionByRNumberResponseDTO>
 */
export class GetProtectionByRNumberCommand
	implements
		IQueryCommand<GetProtectionByRNumberQueryDTO, any, GetProtectionByRNumberResponseDTO>
{
	private apiService: IRestfulApiService
	constructor(apiService: IRestfulApiService) {
		this.apiService = apiService
	}

	execute({
		r_number,
	}: GetProtectionByRNumberQueryDTO): Promise<GetProtectionByRNumberResponseDTO> {
		const url = `/protection`
		const params = new URLSearchParams()
		params.append('r_number', r_number)

		return this.apiService
			.fetch<GetProtectionByRNumberResponseDTO>(url, { params })
			.then((res) => res.data)
	}
}
